import { render, staticRenderFns } from "./SwiftPay.bak.vue?vue&type=template&id=5b5b04a4"
import script from "./SwiftPay.bak.vue?vue&type=script&lang=js"
export * from "./SwiftPay.bak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports